import * as React from 'react'
import { useEffect } from 'react'
import { SideDrawer, SideDrawerForm } from '@sales-center/components'
import { IReferral } from '@sales-center/common'
import { useData, useHandlers } from './hooks'
import { useReferralsContext } from '@user/components/Referrals/context'
import { setReferralActionCreator } from '@user/components/Referrals/state'
import TidalUpdateReferralForm from '../UpdateReferralForm/TidalUpdateReferralForm'
import { ReferralFormVariant } from '@user/components/Referrals/components/UpdateReferral/TidalUpdateReferral'

export type Props = {
  onClose: () => void
  onSave: (referral: IReferral | null) => void
  onReferralValueChange?: (referral: IReferral) => void | undefined
  open: boolean
  referral?: IReferral
  required?: boolean
  salesTeamId: string
  employeeStatus?: 'pending' | 'success' | 'fail'
  formVariant?: ReferralFormVariant
}

export function UpdateReferralDrawer(props: Props) {
  const {
    onClose,
    onSave,
    open,
    salesTeamId,
    referral,
    required,
    formVariant = ReferralFormVariant.Drawer,
  } = props

  const tidalThemeActive = true

  const { drawerTitle, formValid } = useData({ referral })
  const { handleCancel, handleSave } = useHandlers({
    onClose,
    onSave,
    required,
  })

  const [, dispatch] = useReferralsContext()

  useEffect(() => {
    dispatch(setReferralActionCreator(referral || null))
  }, [dispatch, referral])

  const Form = (
    <TidalUpdateReferralForm
      salesTeamId={salesTeamId}
      formVariant={formVariant || ReferralFormVariant.Drawer}
    />
  )

  if (formVariant === ReferralFormVariant.Inline && open) {
    return <>{Form}</>
  }
  return (
    <SideDrawer
      tidalThemeActive={tidalThemeActive}
      title={drawerTitle}
      onClose={handleCancel}
      open={open}
      width={tidalThemeActive ? 457 : 550}
    >
      <SideDrawerForm
        tidalMode={tidalThemeActive}
        onSave={handleSave}
        primaryBtnLabel="Save"
        disableSave={!formValid}
        onCancel={handleCancel}
        containerStyle={{
          py: tidalThemeActive ? 0 : 2.5,
          px: 2.5,
        }}
        saveBtnDataTestId="addReferralSaveBtn"
      >
        {Form}
      </SideDrawerForm>
    </SideDrawer>
  )
}
